import React from "react";
import { ThemeProvider, ToggleButton, ToggleButtonGroup } from "@mui/material";
import toggleTheme from "./toggleTheme";

const CustomToggle = ({
  value,
  onChange,
  options = [],
  exclusive = true,
  size = "medium",
  fullWidth = false,
}) => {
  const handleChange = (event, newValue) => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };

  return (
     <ThemeProvider theme={toggleTheme}>
           <ToggleButtonGroup
      value={value}
      exclusive={exclusive}
      onChange={handleChange}
      size={size}
      fullWidth={fullWidth}
    >
      {options.map((item) => (
        <ToggleButton key={item.value} value={item.value}>
          {item.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
     </ThemeProvider>
 
  );
};

export default CustomToggle;
